/** QuickTicketing — Texte enrichi minimal (commentaires de Claude et des admins) :
 *  paragraphes, listes « - », titres « # », `code`, **gras**, blocs ``` et liens. Aucun HTML brut. */
import React from 'react';

const INLINE = /(`[^`\n]+`|\*\*[^*\n]+\*\*|https?:\/\/[^\s<>)]+)/g;

function inline(text, keyBase) {
  return text.split(INLINE).map((part, i) => {
    const k = `${keyBase}-${i}`;
    if (!part) return null;
    if (part.startsWith('`') && part.endsWith('`') && part.length > 2) return <code key={k}>{part.slice(1, -1)}</code>;
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) return <strong key={k}>{part.slice(2, -2)}</strong>;
    if (/^https?:\/\//.test(part)) return <a key={k} href={part} target="_blank" rel="noreferrer noopener">{part}</a>;
    return <React.Fragment key={k}>{part}</React.Fragment>;
  });
}

export default function RichText({ text }) {
  const blocks = [];
  const lines = String(text || '').split('\n');
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    if (line.startsWith('```')) {
      const body = [];
      for (i++; i < lines.length && !lines[i].startsWith('```'); i++) body.push(lines[i]);
      blocks.push(<pre key={i} className="code-block">{body.join('\n')}</pre>);
    } else if (/^\s*[-*] /.test(line)) {
      const items = [];
      for (; i < lines.length && /^\s*[-*] /.test(lines[i]); i++) items.push(lines[i].replace(/^\s*[-*] /, ''));
      i--;
      blocks.push(<ul key={i}>{items.map((it, j) => <li key={j}>{inline(it, `${i}-${j}`)}</li>)}</ul>);
    } else if (/^#{1,4} /.test(line)) {
      blocks.push(<p key={i} className="rt-h">{inline(line.replace(/^#+ /, ''), i)}</p>);
    } else if (line.trim()) {
      const para = [line];
      for (; i + 1 < lines.length && lines[i + 1].trim() && !/^(\s*[-*] |#{1,4} |```)/.test(lines[i + 1]); i++) para.push(lines[i + 1]);
      blocks.push(<p key={i}>{para.map((l, j) => <React.Fragment key={j}>{j > 0 && <br />}{inline(l, `${i}-${j}`)}</React.Fragment>)}</p>);
    }
  }
  return <div className="rich">{blocks}</div>;
}
